import { PaginationOptions } from '@core/utils/to-pagination-options';

export * from './inputs';
export * from './enums';
export * from './types';

export interface ImportListParams {
  where: any;
  options: PaginationOptions;
}

export interface ImportAcceptedHeaders {
  product_service: string[];
  equipment: string[];
  recurrence: string[];
  location: string[];
}

export interface ImportTypePipeOptions {
  isLower?: boolean;
  isKebabCase?: boolean;
}

export interface ImportAddDialogAfterClosed {
  reloadDataTable?: boolean;
}

export interface ImportForm {
  type: string;
  file: string;
}
